import candidateAvailabilityReducer from './candidateAvailabilities'
import candidateNoteReducer from './candidateNotes'
import candidateProfileReducer from './candidateProfiles'
import companyAccountsReducer from './companyAccounts'
import interviewRequestEventFeedbacksReducer from './interviewRequestEventFeedbacks'
import greenhouseProfileReducer from './greenhouseProfiles'
import hiringTeamReducer from './hiringTeams'
import interviewRequestEventReducer from './interviewRequestEvents'
import interviewRequestMessageReducer from './interviewRequestMessages'
import interviewRequestOfferReducer from './interviewRequestOffers'
import interviewRequestReducer from './interviewRequests'
import memberProfileReducer from './memberProfiles'
import positionReducer from './positions'
import accountManagerReducer from './accountManagers'

export default {
  candidateAvailabilities: candidateAvailabilityReducer,
  candidateNotes: candidateNoteReducer,
  candidateProfiles: candidateProfileReducer,
  companyAccounts: companyAccountsReducer,
  greenhouseProfiles: greenhouseProfileReducer,
  hiringTeams: hiringTeamReducer,
  interviewRequests: interviewRequestReducer,
  interviewRequestEvents: interviewRequestEventReducer,
  interviewRequestEventFeedbacks: interviewRequestEventFeedbacksReducer,
  interviewRequestMessages: interviewRequestMessageReducer,
  interviewRequestOffers: interviewRequestOfferReducer,
  memberProfiles: memberProfileReducer,
  positions: positionReducer,
  accountManagers: accountManagerReducer,
}

import * as candidateAvailabilityEntities from './candidateAvailabilities'
import * as candidateNoteEntities from './candidateNotes'
import * as candidateProfileEntities from './candidateProfiles'
import * as companyAccountsEntities from './companyAccounts'
import * as interviewRequestEventFeedbackEntities from './interviewRequestEventFeedbacks'
import * as greenhouseProfileEntities from './greenhouseProfiles'
import * as hiringTeamEntities from './hiringTeams'
import * as interviewRequestEventEntities from './interviewRequestEvents'
import * as interviewRequestMessageEntities from './interviewRequestMessages'
import * as interviewRequestOfferEntities from './interviewRequestOffers'
import * as interviewRequestEntities from './interviewRequests'
import * as memberProfileEntities from './memberProfiles'
import * as positionEntities from './positions'
import * as accountManagerEntities from './accountManagers'

export {
  candidateAvailabilityEntities,
  candidateNoteEntities,
  candidateProfileEntities,
  companyAccountsEntities,
  interviewRequestEventFeedbackEntities,
  greenhouseProfileEntities,
  hiringTeamEntities,
  interviewRequestEventEntities,
  interviewRequestMessageEntities,
  interviewRequestOfferEntities,
  interviewRequestEntities,
  memberProfileEntities,
  positionEntities,
  accountManagerEntities,
}
